import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatesService {

  constructor() { }

  public hourMinutesZeroStart(): string {
    const date = new Date();
    const heureFormatee = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    return heureFormatee.substring(0, 2) + ':00';
  }

  public hourMinutesZeroEnd(): string {
    const date = new Date();
    date.setHours(date.getHours() + 1);
    const heureFormatee = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    return heureFormatee.substring(0, 2) + ':00';
  }

  public convertDateToISO(dateString: Date): string {
    const date = new Date(dateString);
    return date.toISOString();
  }

  public convertDateToISOWithFixedTime(date: Date, hours: number, minutes: number, seconds: number): string {
    date.setUTCHours(hours);
    date.setUTCMinutes(minutes);
    date.setUTCSeconds(seconds);
    date.setUTCMilliseconds(0);
    return date.toISOString();
  }
}
